import { useRouterPush as usePgRouterPush } from "@polargold/pg-frontend-vue";
import type { RouteLocationRaw } from "vue-router";
import { useRouter } from "vue-router";
import * as Sentry from "@sentry/vue";
import { ROUTE } from "@/router/routeDefinitions.ts";

/**
 * Thin wrapper pinning this app's error policy onto `pg-frontend-vue`'s `useRouterPush`: log to
 * console, report to Sentry, and fall back to the 404/error page - kept here (rather than
 * requiring every one of this app's ~17 call sites to pass the same `onError` callback) so the
 * policy lives in one place.
 */
export const useRouterPush = () => {
    const router = useRouter();

    const goTo404Page = async () => {
        await router.push({ name: ROUTE.ERROR_PAGE.NAME });
    };

    return usePgRouterPush({
        onError: async (error: unknown, to: RouteLocationRaw) => {
            console.group("Routing Error");
            console.error("Error while navigating to", to);
            console.error(error);
            console.groupEnd();
            Sentry.captureException(error);

            try {
                await goTo404Page();
            } catch (fallbackError) {
                console.error("Failed to navigate to the fallback error page:", fallbackError);
            }
        },
    });
};
